/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateOfBirth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function DateOfBirth({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/Fields/DateOfBirth",
  isInvalid,
  onChange
  
}) {
let newPatientPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'new_patient',
path: 'person.birth_date',
format: fromFormat.dateISOIn,
})
let newPatientPersonBirthDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_patient',
path: 'person.birth_date',
validate: fromValidate.birthday,
})
let newPatientPersonBirthDateChangeData = fromData.useDataChange({ viewPath,
context: 'new_patient',
path: 'person.birth_date',
formatOut: fromHelpers.formatOutDate,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 data="new_patient.person.birth_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 validate="/Data/validate.js birthday"
 invalid={!newPatientPersonBirthDateIsValidData}
 value={newPatientPersonBirthDateValueData}
 onChange={newPatientPersonBirthDateChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Date of Birth"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}